import { call, put } from "redux-saga/effects";

import actions from "@/actions";
import { Api, ConfigurationManager } from "@/utils";

/**
 * Loads the floorspace file URL for the current floor space from the API.
 *
 * @param root0 - The action payload.
 * @param root0.siteId - The site ID to load the floorspace file for.
 * @returns The floorspace file URL.
 * @yields Calls the API and dispatches the floorspace file URL.
 */
function* loadFloorspaceFile({ siteId }) {
    const { floorSpaceId } = ConfigurationManager.values;

    const { result: urls } = yield call(
        Api.get,
        `v1/lights-map/site-id/${siteId}/for-eclypse`,
    );

    const floorspaceFileUrl =
        urls.find((url) => url.includes(`/fs${floorSpaceId}/`)) ?? null;

    yield put(actions.map.general.setFloorspaceFileUrl(floorspaceFileUrl));

    return floorspaceFileUrl;
}

export default loadFloorspaceFile;
